module.exports = function() {
  return new Worker(__webpack_public_path__ + "f3749c4aeb89e6b76b46.worker.js");
};